import type { CSSProperties } from 'react';
import { PALETTE_SIZE } from '@betreuung/shared';

/**
 * Person colours are applied through two custom properties rather than through
 * generated class names. That way the twelve palette entries need no safelisting
 * and every colour-aware utility (`person-bg`, `person-tint-cell`, …) works with
 * whatever colour a person happens to have.
 */
export function personVars(colorIndex: number): CSSProperties {
  const index = colorIndex >= 1 && colorIndex <= PALETTE_SIZE ? colorIndex : 1;
  return {
    '--person': `var(--color-cal-${index})`,
    '--person-fg': `var(--color-cal-${index}-fg)`,
  } as CSSProperties;
}

/** The accent colour used for destructive actions (palette entry 9, red). */
export const DESTRUCTIVE_VARS: CSSProperties = {
  '--person': 'var(--color-cal-9)',
  '--person-fg': 'var(--color-cal-9-fg)',
} as CSSProperties;
